/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createStaking = /* GraphQL */ `
  mutation CreateStaking(
    $input: CreateStakingInput!
    $condition: ModelStakingConditionInput
  ) {
    createStaking(input: $input, condition: $condition) {
      id
      bulldroid_id
      wallet_id
      createdAt
      updatedAt
    }
  }
`;
export const updateStaking = /* GraphQL */ `
  mutation UpdateStaking(
    $input: UpdateStakingInput!
    $condition: ModelStakingConditionInput
  ) {
    updateStaking(input: $input, condition: $condition) {
      id
      bulldroid_id
      wallet_id
      createdAt
      updatedAt
    }
  }
`;
export const deleteStaking = /* GraphQL */ `
  mutation DeleteStaking(
    $input: DeleteStakingInput!
    $condition: ModelStakingConditionInput
  ) {
    deleteStaking(input: $input, condition: $condition) {
      id
      bulldroid_id
      wallet_id
      createdAt
      updatedAt
    }
  }
`;
export const createActivity = /* GraphQL */ `
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      wallet_id
      bulldroid_id
      action
      createdAt
      updatedAt
    }
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity(
    $input: UpdateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    updateActivity(input: $input, condition: $condition) {
      id
      wallet_id
      bulldroid_id
      action
      createdAt
      updatedAt
    }
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity(
    $input: DeleteActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    deleteActivity(input: $input, condition: $condition) {
      id
      wallet_id
      bulldroid_id
      action
      createdAt
      updatedAt
    }
  }
`;
